import React from "react"
import clsx from "clsx"

import Spinner from "./Spinner"
import { Tooltip } from "components"
import classes from "./IconButton.module.scss"

const IconButton = props => {
  const {
    size,
    icon,
    onClick = () => { },
    className,
    badge,
    color,
    loadingColor = "white",
    loading,
    disabled,
    tooltip = "",
    badgeClassName
  } = props

  return (
    <Tooltip title={tooltip}>
      <button
        onClick={(e) => !loading && onClick(e)}
        disabled={disabled}
        className={clsx(
          classes["container"],
          disabled && classes["disabled"],
          className
        )}
      >
        {
          badge > 0 &&
          <span className={clsx(classes["badge"], badgeClassName )}>
            {badge > 99 ? "99+" : badge}
          </span>
        }
        {loading
          ?
          <Spinner
            color={loadingColor}
            size={size}
          />
          :
          icon({ size, color })
        }
      </button>
    </Tooltip>
  )
}

export default IconButton